import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../Globals/styles';
import Waves from 'node-waves';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false
    }
  }
  toggleEdit = () => {
    var isEditing = this.state.isEditing;
    this.setState({
      isEditing: !isEditing
    })
  };
  onEditSave = () => {
    const { title, name, telephone, email, id, editContact } = this.props;
    var titleVal = this.refs.title.value;
    var nameVal = this.refs.name.value;
    var telephoneVal = this.refs.telephone.value;
    var emailVal = this.refs.email.value;

    this.setState({
      isEditing: false
    })
    //if nothing is updated return
    if (titleVal+nameVal+telephoneVal+emailVal.replace(/^\s+|\s+$/g, "").length < 1) return;

    var contact = {
      id: id,
      name: nameVal.replace(/^\s+|\s+$/g, "") ? nameVal : name,
      title: titleVal.replace(/^\s+|\s+$/g, "") ? titleVal : title,
      telephone: telephoneVal.replace(/^\s+|\s+$/g, "") ? telephoneVal : telephone,
      email: emailVal.replace(/^\s+|\s+$/g, "") ? emailVal : email
    }
    editContact(contact);
  };
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  render () {
  const { title, name, telephone, email } = this.props;
  const tellink = "tel:" + telephone;
  const mailto = "mailto:" + email;
  return (
    <div style={[styles.contact, this.props.style]}>
     {this.state.isEditing ?
      <div>
        <div style={styles.line}>
          <input
            type="text"
            placeholder={title}
            ref="title"
            style={styles.lineInputField}/>
          <i key="saveIcon" onClick={this.onEditSave} style={[styles.saveIcon]} className="fa fa-floppy-o waves-icon" />
          <i key="editIcon" onClick={this.toggleEdit} style={[styles.editIcon, styles.editIconActive]} className="fa fa-pencil waves-icon" />
        </div>
        <div style={styles.line}>
          <i className="fa fa-user" style={styles.icons}></i>
          <input
            type="text"
            placeholder={name}
            ref="name"
            style={styles.lineInputField}/>
        </div>
        <div style={styles.line}>
          <i className="fa fa-phone" style={styles.icons}></i>
          <input
            type="text"
            placeholder={telephone}
            ref="telephone"
            style={styles.lineInputField}/>
        </div>
        <div style={styles.line}>
          <i className="fa fa-envelope-o" style={[styles.icons, styles.mailIcon]}></i>
          <input
            type="text"
            placeholder={email}
            ref="email"
            style={styles.lineInputField}/>
        </div>
      </div>
      :
      <div>
        <div style={[styles.line, styles.title]}>
          {title ? title : '-'}
          <i key="editIcon2" onClick={this.toggleEdit} style={[styles.editIcon]} className="fa fa-pencil waves-icon" />
        </div>
        <div style={styles.line}>
            <i className="fa fa-user" style={styles.icons}></i>
            <div>{name}</div>
        </div>
        <div style={styles.line}>
          <i className="fa fa-phone" style={styles.icons}></i>
          <a key="phone" style={styles.a} href={tellink}>{telephone}</a>
        </div>
        <div style={styles.line}>
          <i className="fa fa-envelope-o" style={[styles.icons, styles.mailIcon]}></i>
          <a key="mail" style={styles.a} href={mailto}>{email}</a>
        </div>
      </div>
      }
    </div>
    );
  }
}

var styles = {
  contact : {
    color: semanticColors.text,
    backgroundColor: semanticColors.default,
    fontSize: '14px',
    padding:'0 10px',
    height: '140px',
    width: '100%',
    overflow: 'hidden',
    textAlign: 'left'
  },
  title:{
    color: greyScaleColors.greyLight
  },
  line: {
    height: '35px',
    width: '100%',
    paddingLeft: '40px',
    position: 'relative',
    lineHeight: '35px',
    paddingRight: '60px'
  },
  a: {
    color: semanticColors.primary,
    ':hover': {
      color: semanticColors.primaryDark
    }
  },
  icons: {
    position: 'absolute',
    left: '10px',
    lineHeight: '37px',
    fontSize: '20px'
  },
  mailIcon: {
    fontSize: '18px'
  },
  editIcon: {
    position: 'absolute',
    right: '0',
    fontSize: '20px',
    cursor: 'pointer',
    lineHeight:'30px',
    marginTop: '5px',
    width: '30px',
    height: '30px',
    color: semanticColors.text
  },
  saveIcon:{
    position: 'absolute',
    right: '30px',
    fontSize: '20px',
    cursor: 'pointer',
    lineHeight:'30px',
    width: '30px',
    height: '30px',
    marginTop: '5px',
    color: semanticColors.text
  },
  editIconActive:{
    color: semanticColors.info
  },
  lineInputField: {
    height: '31px',
    lineHeight: '31px',
    border: 'none',
    width: '100%',
    paddingLeft: '5px',
    borderRadius: '2px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset'
  }
}

  Contact.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    telephone: PropTypes.string,
    title: PropTypes.string,
    email: PropTypes.string,
    editContact: PropTypes.func.isRequired
  };

export default Radium(Contact);


// WEBPACK FOOTER //
// ./src/App/Project/Dashboard/ProjectCard/contact.jsx